import {
  collection,
  getDocs,
  query,
  QueryConstraint,
  where,
} from "firebase/firestore";
import { db } from "../../config/firebase-config";
import useColection from "../colection";
import { useContext } from "react";
import { UserContext } from "../../context";

const useServiceOrders = () => {
  const { get, uploadPhoto, ...others } =
    useColection<ServiceOrder>("service-orders");

  const userWorker = useContext(UserContext);

  const getServiceOrders = () => {
    return get(/*[where("companyId", "==", userWorker.user?.companyId)]*/);
  };

  return { ...others, get: getServiceOrders };
};

export default useServiceOrders;
